import { render, staticRenderFns } from "./StartModalNotYetActivated.vue?vue&type=template&id=827890b4"
import script from "./StartModalNotYetActivated.vue?vue&type=script&lang=js"
export * from "./StartModalNotYetActivated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports